/** @format */

const emailProviders = require("../../data/emailProviders");
const remoteConfig = require("./remote");

module.exports = {
  partnerId: "mybet",
  partnerName: "mybet",
  country: null,
  fallbackCountry: "GB",
  restrictedCountries: [
    /* not roots */
    "AT"
  ],
  featuredCountries: ["DE", "LU", "LI"],
  languages: [
    "en",
    "sv",
    "de",
    "fi",
    "no",
    "po",
    "ja",
    "nl",
    "fr",
    "es",
    "it",
    "da",
    "tr",
  ],
  oneInputAddressCountries: [
    "AE",
    "VN",
    "RO",
    "IN",
    "CN",
    "MT",
    "IE",
    "RU",
    "UA",
  ],
  ibanCountries: [], // List of IBAN countries to check
  language: null,
  selectableCurrencies: ["sek", "eur"], // ['currency'] - not releated by countries, [{id:'usd', countries: ['ca']}] - related to countries
  fallbackLanguage: "en-GB",
  hidePasswordByDefault: ["desktop"], // accept ['mobile','desktop'] or false
  loginRedirectURL: "/base.html",
  loginRedirectOnOverview: false,
  forceMobileOTPDeliveryMethod: "", // Accepts a String OR an Object | String (apply to all countries) - accepts MOBILE=sms or DISPLAY=flash-sms, if nothing is set, it'll fallback to global api settings | Object (apply to specific countries) - accepts Country code and Otp delivery type - {C1 : 'MOBILE', C2: 'DISPLAY' }
  defaultGeoIPService: "regily",
  passwordRules: {
    minLength: 8,
    maxLength: 20,
    letters: true,
    letterCasing: false,
    digits: true,
    specials: false,
    digitsOrSpecials: false, // if we want either digits or specials and not both
    restrictedProperties: ["email"], // [Takes effect if "password-warning" screen is present only]. Properties to restrict from the password, accepts ['email', 'name', 'username','birthdate'], if nothing is set, it defaults to ALL.
    customConfig: {
      mode: false, // set to 'flexible' to enable
      criteria: ["lowercase", "uppercase", "digit", "special"],
      minimumMatchingCriteria: 3, // minimum criteria that the password must match
      validateEmail: false,
    },
  },
  fullNameRegExp: /[^a-zA-Zａ-ｚＡ-Ｚ\-ÆÐƎƏƐƔĲŊŒẞÞǷȜæðǝəɛɣĳŋœĸſßþƿȝĄƁÇĐƊĘĦĮƘŁØƠŞȘŢȚŦŲƯY̨Ƴąɓçđɗęħįƙłøơşșţțŧųưy̨ƴÁÀÂÄǍĂĀÃÅǺĄÆǼǢƁĆĊĈČÇĎḌĐƊÐÉÈĖÊËĚĔĒĘẸƎƏƐĠĜǦĞĢƔáàâäǎăāãåǻąæǽǣɓćċĉčçďḍđɗðéèėêëěĕēęẹǝəɛġĝǧğģɣĤḤĦIÍÌİÎÏǏĬĪĨĮỊĲĴĶƘĹĻŁĽĿʼNŃN̈ŇÑŅŊÓÒÔÖǑŎŌÕŐỌØǾƠŒĥḥħıíìiîïǐĭīĩįịĳĵķƙĸĺļłľŀŉńn̈ňñņŋóòôöǒŏōõőọøǿơœŔŘŖŚŜŠŞȘṢẞŤŢṬŦÞÚÙÛÜǓŬŪŨŰŮŲỤƯẂẀŴẄǷÝỲŶŸȲỸƳŹŻŽẒŕřŗſśŝšşșṣßťţṭŧþúùûüǔŭūũűůųụưẃẁŵẅƿýỳŷÿȳỹƴźżžẓ\u{3040}-\u{30ff}\u{3400}-\u{4dbf}\u{4e00}-\u{9fff}\u{f900}-\u{faff}\u{ff66}-\u{ff9f}\u{0400}-\u{04FF}\s]/gu,
  animateOverview: false,
  animateSelectors: true,
  minimumBirthAge: { default: 18, CA: 19 }, // {default: 18} - default value of minimum birth age. {COUNTRY: VALUE} - for specific country value
  allowBackFromFirstScreen: false,
  mobileCountryPrefixSettings: {
    // options: [],
    mode: "all",
    /**
     * Above accepts values:
     *  - 'all' [default and fallback]: Country and Mobile number can be from different countries, and all prefixes are allowed
     *  - 'one': Country and Mobile number have to be from the same country, and no prefix edit option
     *  - 'restrict': restrict the countries in the options property from the prefixes list
     *  - 'allow': allow only the countries in the options property to be shown in the prefixes list
     */
  },
  allowFourDigitYear: true,
  waitForCallback: [],
  socialMedia: {
    enabled: false,
    allowOnlyLoggedIn: false, // Allow only user who are already logged in to a service; Support: Facebook only
    facebookAppId: "1940626266248961",
    googleId:
      "485912056311-pdk2vl5uis0a7cvp4ep5p6f7fuuffkl2.apps.googleusercontent.com",
    linkedInId: "7803pkog06nlor",
  },
  googleAutocompleteKey: "AIzaSyBrCAzXUH_wzRJEmQw9StDs2aD7GTNWsvc", // set this to 'AIzaSyBrCAzXUH_wzRJEmQw9StDs2aD7GTNWsvc' or another google places API key to enable places autocomplete or false to disable
  showRegilyBadge: false,
  dataTransformSchema: false,
  recaptcha: {
    enabled: false,
    options: {
      // https://developers.google.com/recaptcha/docs/display#explicit_render
      // Supported in config: sitekey, theme, size, tabindex
      sitekey: "6Lf9sGMUAAAAAMLxZbaNoh0JhK7vKAkXP6R0Q-Pl",
    },
  },
  sanctionsLookup: {
    enabled: true,
    useCustomLookup: true, // Use the new sanctions lookup instead of opensanctions provider
    defaultBackendService: "sanctions",
  },
  sentry: {
    dsn: "https://bc19233d660248d29959a406bd2fd10c@sentry.io/1393987",
  },
  enableRegilyAnalyzer: false,
  allowDataLookup: true,
  useDynamicCopy: false,
  useDynamicCopyFromOwnSubDomain: false,
  allowIncorrectEmail: true, // true to show the "it's correct" button on email validation
  externalLinks: {
    getLink: (locale, extension = "com") => ({
      terms: `https://www.mybet.${extension}/${locale}/info/terms-conditions`,
      privacy: `https://www.mybet.${extension}/${locale}/info/privacy-policy`,
      readMore: ``,
    }),
    enabled: true, // used to prevent issues on gradual release
  },
  remoteConfig,
  alertBar: {
    enabled: false,
    countries: true, // Accepts boolean or an array list of allowed countries
    openLinkInExternal: false, // true to open links in new tab
    enableCollapsing: false, // allow to toggle alert content
  },
  addressProof: {
    enabled: true,
  },
  blockPostalCodes: true, // can also be set in customData by value `blockPostalCodes`
  // if we want to block other than postal codes in blockedPostals.js we can add `blockedPostalCodes` to custom data, and this will overwrite default postal codes
  hideSHProvince: false, // can also be set in customData by value `hideSHProvince`
  hideBonusConfigOnRemote: true, // Accepts boolean, Show or Hide Bonus content if remote is enabled
  noDataPersistenceCountries: [], // to disable prefilling inputs (credentials, user...etc) based on previously entered values stored in the sessionStorage
  noPersonalDataLookupCountries: [], // to disabled the address, name & gender lookup/prefilling
  noSpecificContentCountries: [], // to hide the hint for the phone number, country selection on the postal code screen, disable don't remember flow, disable phone validation and disable postal code masking
  // if we want to block other than postal codes in blockedPostals.js we can add `blockedPostalCodes` to custom data, and this will overwrite default postal codes
  enableEmailSuggestion: false,
  suggestionsProvider: {
    enabled: true,
    providers: emailProviders,
  },
  tooltip: {
    enabled: false,
  },
  otpProvider: {
    default: [], // set which provider to use by country for each sending attempt, each item in the array represent which provider to use for the corresponding attempt, e.i: ['attemp1' => otp1,'attemp2' => otp2....]
  },
  findClosestStreet: false,
  emailPath: "/chapter1/email",
  loginRedirectURLRemote: "https://www.mybet.com",
  germanRegulations: {
    documentUpload: {
      enabled: true,
    },
  },
};



// WEBPACK FOOTER //
// ./src/partners/config/settings.js